import { Box } from '@mui/material';

export function PageWrapper(props: { children?: JSX.Element | JSX.Element[] }) {
  return <Box sx={{ margin: '2% 8% 5% 8%' }}>{props.children}</Box>;
}

export function PageTitle(props: { title: string }) {
  return <h1 style={{ textAlign: 'left' }}>{props.title}</h1>;
}
